import styled from 'styled-components'

export const Wrapper = styled.div`
  > div {
    padding: 0;
    padding-top: 24px;
    > div + div {
      padding: 8px 0 16px;
    }
    > div + div + div {
      padding: 0;
    }
  }
`
